export default "__VITE_ASSET__DtGn2xHM__"